
  import { defineComponent } from 'vue';

  export default defineComponent({
    name: 'CodeCellRenderer',
    props: {
      code: {
        type: String,
        default: '',
      },
    },
    computed: {
      formattedCode() {
        if (!this.code) return '';
        return this.code.split(',').join(',<br>');
      },
    },
  });
